import { DROP_SHOW_HIDE } from '../constants'
import {handleActions} from 'redux-actions';

export const dropDown = handleActions({
    [DROP_SHOW_HIDE]: (state) => ({show: !state.show})
},{show: false});